module.exports = __webpack_public_path__ + "934490a8d6d147ca5ced8674c5efdcef.svg";